import React, { Suspense, useMemo, useState } from 'react';
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { institucionFinanciera } from '../models/institucionFinanciera';
import ModalInstituciones from '../components/modalInstituciones';
import { useColumns } from '../utils/columns';
import { exportExcel } from '../../../../utils/exportExcel';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { Box, Paper } from '@mui/material';
import FloatingButton from '../../../../components/ui/materialui/floatingButton';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';
import { PermissionGuard } from '../../../../components/auth/ProtectedRoute';
import { TipoFuncionalidad } from '../../../../utils/enums';

function InstitucionFinanciera() {
  
  const [isLoading, setIsLoading] = React.useState(false)
  const [refresh, setRefresh] = useState(false)

  const [modalDetalle, setModalDetalle] = useState<boolean>(false)
  const [institucionEditar, setInstitucionEditar] = useState<institucionFinanciera>()
  

  const urlTabla = `siscred-api-maestros/v1/institucion-financiera/listar`;

  const control = useDataFetch(
      urlTabla,
      undefined,
      true,
    )

  const { COLUMNS } = useColumns({ control, setInstitucionEditar, setModalDetalle });
  const columns = useMemo(() => COLUMNS, [control]);

  const breadcrumbItems = [
    { label: 'Inicio', url: '/' },
    { label: 'Maestros', url: `/maestros` },
    { label: 'Instituciones financieras', active: true },
  ]

  return (
    <>
      <Suspense>
        <Breadcrumb items={breadcrumbItems} />
        <Box sx={{ mt: 2 }}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Suspense>
              <Tabla
                  columns={columns}
                  control={control}
                  url={urlTabla}
                  titulo={
                    <TableHeader
                      title=""
                      control={control}
                      button={
                        <PermissionGuard permissions={[TipoFuncionalidad.Maestros_editar]}>
                        <MButton
                          type="button"
                          variant="contained"
                          onClick={() => { setModalDetalle(true); setInstitucionEditar(undefined); }}
                          startIcon={<AddTwoToneIcon />}
                        >
                          Nueva
                        </MButton>
                        </PermissionGuard>
                      }
                      buttonExport={
                        <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                        <MButton
                          type="button"
                          variant="outlined"
                          onClick={() => exportExcel(control.data, columns, "INSTITUCION")}
                          startIcon={<SummarizeTwoToneIcon />}
                        >
                          Exportar
                        </MButton>
                        </PermissionGuard>
                      }
                    />
                  }
                />
            </Suspense>
          </Paper>
        </Box>
      </Suspense>

      <ModalInstituciones
        show={modalDetalle}
        datosEditar={institucionEditar}
        onHide={() => setModalDetalle(false)}
        refresh={() => control.fetchData()}
        setisloading={setIsLoading}
        setrefresh={setRefresh}
      />
  
  </>)
  
}

export default InstitucionFinanciera;